// React Grid Layout imports for drag-and-drop functionality
// @ts-ignore
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

// Create ResponsiveGridLayout component
const ResponsiveGridLayout = WidthProvider(Responsive);

import {
  TopMisconfiguration,
  OnPremLowestCompliance,
  OnPremLowestCveScore,
  OnPremLowestScore,
  OnPremClassification,
  CloudAccount,
  Tags,
  Mitre,
  Cve,
  TopCve,
  IntelliScore,
} from "../../modules/dashboard";
import JiraTickets from "../../modules/dashboard/jira_tickets/jira_tickets";
import { useEffect, useState, useCallback } from "react";
import axiosInstance from "../../axios/axios";
import { END_POINTS } from "../../shared";
import { useEncryptService, useStorageManager } from "../../shared/hooks";
import moment from "moment-timezone";
import ExpiredAccountDialog from "../Account/ExpiredAccountDialog";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  TextField,
  Typography,
  Menu,
  MenuItem,
  Switch,
  ListItemText,
} from "@mui/material";
import { Visibility, VisibilityOff, Settings, Save } from "@mui/icons-material";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import NoData_img1 from "../../assets/baseVersion/Nodata.svg";
import SubscriptionViewPlan from "../Account/Subscription_ViewPlan";
import CyberResilienceView from "../../modules/dashboard/cyber_resilience/CyberResilienceView";
import Misconfiguration from "../../modules/dashboard/misconfiguration/Misconfiguration";
import useDashboardService from "../../modules/dashboard/services";
import { DashboardProvider } from "../../modules/dashboard/DashboardContext";
import ComplianceTrends from "./compliancetrends";
import Assets from "./Assests";
import eventEmitter from "../../components/utils/eventEmitter";
import { authActions } from "../../store/authSlice";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../components/loader/loading";
import { RootState } from "../../store/store";
import DeactivateAccountDialog from "../Account/DeactivateAccountDialog";
import useRolePermissions from "../../shared/hooks/useRolePermissions";
import { ROLES_ROUTE } from "../../shared/constants/constant-data";

const getDaysDiff = (expiry: string, timezone: string = "UTC") => {
  const today = moment.tz(timezone).startOf("day");
  const expiryDate = moment.tz(expiry, timezone).startOf("day");
  return expiryDate.diff(today, "days");
};

interface UserDetails {
  expiry_date: string;
  timezone?: string;
  organization_deactivated?: boolean;
}

const Home: React.FC = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  const [dialogType, setDialogType] = useState<
    "edit" | "pause" | "delete" | "resume" | null
  >(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeactivateDialog, setOpenDeactivateDialog] = useState(false);
  const { isAssetInventory, hasPermissions } = useRolePermissions();
  console.log(isAssetInventory(), "isAssetInventory===================");
  const [userData, setUserData] = useState<Record<string, any>>({});
  const [isNewUserDetails, setIsNewUserDetails] = useState({});
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const { doEncryptLogin } = useEncryptService();
  const { getFromLocalStorage, saveToLocalStorage } = useStorageManager();
  const navigate = useNavigate();
  const [daysdiff, setDaysDiff] = useState(0);
  const [isViewPlans, setIsViewPlans] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isUserTypeLoading, setIsUserTypeLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState<any>(null);
  const dashboardService = useDashboardService();

  // Track when any widget overlay is open to disable drag and drop
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  
  // Track button disable state to prevent multiple clicks
  const [isResetDisabled, setIsResetDisabled] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);

  // Get user selectors
  const isNewUserTrue = useSelector(
    (state: RootState) => state.UserLoginDetails.isNewUserTrue
  );
  const isOnlyCloudUser = useSelector(
    (state: RootState) => state.UserLoginDetails.isOnlyCloudUser
  );
  const isOnlyPremAssetUser = useSelector(
    (state: RootState) => state.UserLoginDetails.isOnlyPremAssetUser
  );
  const isBothCloudAndPremAssetUser = useSelector(
    (state: RootState) => state.UserLoginDetails.isBothCloudAndPremAssetUser
  );
  // Whether organization / user logged in via SSO (set during login flow)
  // Whether organization / user logged in via SSO (set during login flow)
  const isSsoEnabled = useSelector((state: RootState) => state.UserLoginDetails.sso_enabled);
  console.log(isSsoEnabled, "isSsoEnabled");

  // Default layout configuration
  const defaultLayouts = {
    lg: [
      // Row 1: Top 3 widgets
      { i: 'intelliscore', x: 0, y: 0, w: 4, h: 4, minW: 2, maxW: 12, minH: 2, static: false },
      { i: 'misconfiguration', x: 4, y: 0, w: 4, h: 4, minW: 2, maxW: 12, minH: 2, static: false },
      { i: 'assets', x: 8, y: 0, w: 4, h: 4, minW: 2, maxW: 12, minH: 2, static: false },

      // Row 2: Cyber resilience and compliance
      { i: 'cyber-resilience', x: 0, y: 4, w: 6, h: 4.5, minW: 3, maxW: 12, minH: 3, static: false },
      { i: 'compliance-trends', x: 6, y: 4, w: 6, h: 4.5, minW: 3, maxW: 12, minH: 3, static: false },

      // Row 3: MITRE + CVE + Tags
      { i: 'mitre', x: 0, y: 8.5, w: isOnlyCloudUser ? 9 : 6, h: 6, minW: 3, maxW: 12, minH: 3, static: false },
      { i: 'cve', x: 6, y: 8.5, w: 3, h: 6, minW: 2, maxW: 12, minH: 3, static: false },
      { i: 'tags', x: 9, y: 8.5, w: 3, h: 6, minW: 2, maxW: 12, minH: 3, static: false },

      // Row 4: Classification tables
      { i: 'onprem-classification', x: 0, y: 14.5, w: 6, h: 4, minW: 3, maxW: 12, minH: 2, static: false },
      { i: 'cloud-account', x: 6, y: 14.5, w: 6, h: 4, minW: 3, maxW: 12, minH: 2, static: false },

      // Row 5-8: Bottom tables
      { i: 'top-misconfiguration', x: 0, y: 18.5, w: 6, h: 4, minW: 3, maxW: 12, minH: 2, static: false },
      { i: 'onprem-lowest-score', x: 6, y: 18.5, w: 6, h: 4, minW: 3, maxW: 12, minH: 2, static: false },
      { i: 'onprem-lowest-cve', x: 0, y: 22.5, w: 6, h: 4, minW: 3, maxW: 12, minH: 2, static: false },
      { i: 'top-cve', x: 6, y: 22.5, w: 6, h: 4, minW: 3, maxW: 12, minH: 2, static: false },
      { i: 'onprem-lowest-compliance', x: 0, y: isOnlyCloudUser ? 18.5 : 26.5, w: 6, h: 4, minW: 3, maxW: 12, minH: 2, static: false },
      { i: 'jira-tickets', x: isOnlyCloudUser ? 0 : 6, y: 26.5, w: 6, h: 4, minW: 3, maxW: 12, minH: 2, static: false },
    ]
  };

  // Layout filtering based on user type
  const getFilteredLayouts = useCallback(() => {
    const userType = {
      isCloud: isOnlyCloudUser,
      isPrem: isOnlyPremAssetUser,
      isBoth: isBothCloudAndPremAssetUser
    };

    const includedWidgets = new Set<string>([
      'intelliscore', 'misconfiguration', 'assets',
      'cyber-resilience', 'compliance-trends',
      'mitre', 'tags',
      'top-misconfiguration', 'onprem-lowest-score', 'onprem-lowest-compliance', 'jira-tickets'
    ]);

    if (!userType.isCloud) {
      includedWidgets.add('cve');
      includedWidgets.add('onprem-lowest-cve');
      includedWidgets.add('top-cve');
      // includedWidgets.add('jira-tickets');
      // includedWidgets.add('onprem-lowest-compliance');
    }

    if (userType.isBoth || userType.isPrem) {
      includedWidgets.add('onprem-classification');
    }

    if (userType.isBoth || userType.isCloud) {
      includedWidgets.add('cloud-account');
    }

    // if (!userType.isPrem) {
    //   includedWidgets.add('onprem-lowest-compliance');
    // }

    // Priority: Server preferences > localStorage > defaults
    const currentUserTypeKey = `${userType.isCloud}-${userType.isPrem}-${userType.isBoth}`;
    // Check for server-side preferences from userDetails
    const userDetailsStr = localStorage.getItem('userDetails');
    if (userDetailsStr) {
      try {
        const userDetails = JSON.parse(userDetailsStr);
        if (userDetails.dashboard_preferences?.layout?.lg) {
          const serverLayout = userDetails.dashboard_preferences.layout;
          const serverWidgets = serverLayout.lg.map((item: any) => item.i);
          const allValid = serverWidgets.every((w: string) => includedWidgets.has(w));
          
          if (allValid && serverLayout.lg.length > 0) {
            // Also sync to localStorage for future use
            localStorage.setItem('dashboard-layout', JSON.stringify(serverLayout));
            localStorage.setItem('dashboard-user-type', currentUserTypeKey);
            return serverLayout;
          }
        }
      } catch (e) {
        console.warn('Failed to parse server dashboard preferences:', e);
      }
    }

    // Fallback to localStorage
    const savedLayout = localStorage.getItem('dashboard-layout');
    const savedUserType = localStorage.getItem('dashboard-user-type');

    if (savedLayout && savedUserType === currentUserTypeKey) {
      try {
        const parsed = JSON.parse(savedLayout);
        const savedWidgets = parsed.lg.map((item: any) => item.i);
        const allValid = savedWidgets.every((w: string) => includedWidgets.has(w));

        if (allValid) {
          return parsed;
        }
      } catch (e) {
        console.warn('Failed to parse saved layout:', e);
      }
    } else if (savedLayout && savedUserType !== currentUserTypeKey) {
      localStorage.removeItem('dashboard-layout');
    }

    let filteredLayout = defaultLayouts.lg.filter(item => includedWidgets.has(item.i));

    if (userType.isCloud) {
      filteredLayout = filteredLayout.map(item => {
        if (item.i === 'intelliscore') {
          return { ...item, w: 3, h: 4.5, x: 0, y: 0, minW: 3, maxW: 6 };
        }
        if (item.i === 'misconfiguration') {
          return { ...item, w: 3, h: 4.5, x: 3, y: 0, minW: 3, maxW: 6 };
        }
        if (item.i === 'assets') {
          return { ...item, w: 6, x: 6, y: 0, h: 4.5, minW: 4, maxW: 12 };
        }
        if (item.i === 'cyber-resilience') {
          return { ...item, x: 0, y: 5, w: 6 };
        }
        if (item.i === 'compliance-trends') {
          return { ...item, x: 6, y: 5, w: 6 };
        }
        return item;
      });
    } else if (userType.isBoth) {
      filteredLayout = filteredLayout.map(item => {
        if (item.i === 'intelliscore') {
          return { ...item, w: 6, h: 5, x: 0, y: 0 };
        }
        if (item.i === 'misconfiguration') {
          return { ...item, w: 6, h: 5, x: 6, y: 0 };
        }
        if (item.i === 'assets') {
          return { ...item, w: 12, x: 0, y: 5, h: 2.5 };
        }
        if (item.i === 'cyber-resilience') {
          return { ...item, x: 0, y: 7.5, w: 6 };
        }
        if (item.i === 'compliance-trends') {
          return { ...item, x: 6, y: 7.5, w: 6 };
        }
        return item;
      });
    }

    localStorage.setItem('dashboard-user-type', currentUserTypeKey);

    return { lg: filteredLayout };
  }, [isOnlyCloudUser, isOnlyPremAssetUser, isBothCloudAndPremAssetUser]);

  const [layouts, setLayouts] = useState<any>({ lg: [] });
  const [hiddenWidgets, setHiddenWidgets] = useState<Set<string>>(new Set());

  // Initialize layout after Redux is ready
  useEffect(() => {
    if (isOnlyCloudUser !== undefined && isOnlyPremAssetUser !== undefined && isBothCloudAndPremAssetUser !== undefined) {
      const loadedLayouts = getFilteredLayouts();
      setLayouts(loadedLayouts);

      // Priority: Server preferences > localStorage for hidden widgets
      const userDetailsStr = localStorage.getItem('userDetails');
      let serverHiddenWidgets: string[] | null = null;
      let hasServerPreferences = false;
      
      if (userDetailsStr) {
        try {
          const userDetails = JSON.parse(userDetailsStr);
          // Check if server has dashboard_preferences (even if hidden_widgets is empty)
          if (userDetails.dashboard_preferences) {
            hasServerPreferences = true;
            serverHiddenWidgets = userDetails.dashboard_preferences.hidden_widgets || [];
          }
        } catch (e) {
          console.warn('Failed to parse server hidden widgets:', e);
        }
      }

      if (hasServerPreferences && serverHiddenWidgets) {
        // Use server preferences (could be empty array, meaning all widgets visible)
        setHiddenWidgets(new Set(serverHiddenWidgets));
        // Sync to localStorage
        localStorage.setItem('hidden-widgets', JSON.stringify(serverHiddenWidgets));
      } else {
        // Fallback to localStorage
        const savedHidden = localStorage.getItem('hidden-widgets');
        if (savedHidden) {
          try {
            const parsed = JSON.parse(savedHidden);
            setHiddenWidgets(new Set(parsed));
          } catch (e) {
            console.warn('Failed to load hidden widgets:', e);
          }
        }
      }
    }
  }, [isOnlyCloudUser, isOnlyPremAssetUser, isBothCloudAndPremAssetUser, getFilteredLayouts]);

  // Layout change handler
  const onLayoutChange = (currentLayout: any, allLayouts: any) => {
    if (allLayouts.lg) {
      const validatedLayout = allLayouts.lg.map((item: any) => {
        let validatedItem = { ...item };

        if (validatedItem.x + validatedItem.w > 12) {
          validatedItem.x = Math.max(0, 12 - validatedItem.w);
        }
        if (validatedItem.x < 0) {
          validatedItem.x = 0;
        }
        if (validatedItem.y < 0) {
          validatedItem.y = 0;
        }

        return validatedItem;
      });

      const updatedLayouts = { ...allLayouts, lg: validatedLayout };
      setLayouts(updatedLayouts);

      try {
        localStorage.setItem('dashboard-layout', JSON.stringify(updatedLayouts));
      } catch (e) {
        console.warn('Failed to save layout:', e);
      }

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 100);
    }
  };

  const onResizeStop = () => {
    window.dispatchEvent(new Event('resize'));
  };

  console.log(isOnlyPremAssetUser, "isOnlyPremAssetUser");
  console.log(isOnlyCloudUser, "isOnlyCloudUser");
  console.log(isNewUserTrue, "isNewUserTrue");
  console.log(isBothCloudAndPremAssetUser, "isBothCloudAndPremAssetUser");

  const [complianceData, setComplianceData] = useState({
    CSC: 60,
    CIS_V8: 60,
    NIST_800_53: 60,
    NIST_800_51: 60,
    HIPPA: 60,
    PCI_DSS: 60,
  });
  const [trigger, setTrigger] = useState(0);

  const dispatch = useDispatch();
  const [assetsRowData, setAssetsRowData] = useState<any[]>([]);
  let url = END_POINTS.DEVICE_LIST;

  useEffect(() => {
    const handleFilterSaved = () => {
      setIsLoading(true);
      setTrigger((prev) => prev + 1);
    };

    eventEmitter.on("filterSaved", handleFilterSaved);

    return () => {
      eventEmitter.off("filterSaved", handleFilterSaved);
    };
  }, []);

  const dataMassage = (data: any) => {
    data?.forEach((element: any) => {
      element.security_score_rounded = parseInt(element.security_score)
        ? Math.floor(element.security_score)
        : element.security_score;
      element.vendor = makeFirstLetterCapital(element.vendor);
      const formattedDate = element.last_scan
        ? moment(element.last_scan).format("D, MMMM, YYYY")
        : "";
      element.last_scan_date = formattedDate;
      element.region_name = element.region_name
        ? element.region_name
        : "Unassigned";
      element.failed_count = element.vulnerability_levels?.failed_count ?? null;
    });
    data.sort((a: any, b: any) => {
      const dateA = a.last_scan ? new Date(a.last_scan).getTime() : 0;
      const dateB = b.last_scan ? new Date(b.last_scan).getTime() : 0;
      return dateB - dateA;
    });
    data.forEach((element: any, index: number) => {
      element.number = index + 1;
    });
  };

  const makeFirstLetterCapital = (str: any) => {
    if (str) {
      return str.charAt(0).toUpperCase() + str.substring(1);
    } else {
      return "";
    }
  };

  const fetchAssetsData = async () => {
    try {
      const roleReq: any = {
        type: 1,
      };
      const response = await axiosInstance.post(url, roleReq);
      if (response.status === 200) {
        const result = response.data?.data?.device_list || [];
        dataMassage(result);

        setAssetsRowData(result);
        const assetsDetails = result.map((data: any) => ({
          device_name: data.device_name,
          device_id: data.id,
        }));
        dispatch(
          authActions.login({
            assetsData: assetsDetails,
          })
        );
      }
    } catch (error: any) {
      console.error("Error fetching assets data:", error);
    }
  };

  useEffect(() => {
    const initializeDashboard = async () => {
      setIsLoading(true);

      const userDataFromStorage = JSON.parse(
        getFromLocalStorage("userDetails") || "{}"
      ) as UserDetails;

      const daysDiff = getDaysDiff(
        userDataFromStorage.expiry_date,
        userDataFromStorage.timezone || "UTC"
      );
      setDaysDiff(daysDiff);
      if (daysDiff <= 0 && !(window as any).__roleLogoutInProgress) {
        setOpenDialog(true);
      }
      if (userDataFromStorage.organization_deactivated === true) {
        setOpenDeactivateDialog(true);
      }

      const fetchAllData = async () => {
        try {
          // Fetch dashboard data
        } catch (error: unknown) {
          console.error("Error fetching dashboard data:", error);
        } finally {
          setTimeout(() => {
            setIsLoading(false);
          }, 800);
        }
      };

      fetchAllData();
    };

    initializeDashboard();
  }, [
    trigger,
    isBothCloudAndPremAssetUser,
    isOnlyPremAssetUser,
    isOnlyCloudUser,
  ]);

  const handleOpenDialog = (type: "edit" | "pause" | "resume" | "delete") => {
    setDialogType(type);
  };

  const handleDelete = async (password: string) => {
    const password_encrypt = {
      password: doEncryptLogin(password),
    };
    try {
      const response = await axiosInstance.post(
        END_POINTS.PASSWORD_CONFIRMATION,
        password_encrypt
      );
      if (response.status === 200) {
        toast.success("Organization data deleted successfully", {
          type: "success",
        });
        setDialogType(null);
        navigate("/login/delete");
      }
    } catch (error: any) {
      // Try to show a user-friendly toast using the server message when available
      const serverMessage =
        error?.response?.data?.message || error?.message || "Failed to delete data";

      // Show toast to user for incorrect password or other failures
      toast.error(serverMessage);

      // Also show inline helper under the password field
      setPasswordError(serverMessage);

      console.error("Error deleting VPN:", error);
    }
  };

  const handleCloseDialog = (event: any, reason: any) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") {
      return;
    }
    setDialogType(null);
    setPassword("");
    if (daysdiff <= 0) {
      setOpenDialog(true);
    }
  };

  // Widget settings
  const [widgetToggleAnchor, setWidgetToggleAnchor] = useState<null | HTMLElement>(null);

  const widgetNames: Record<string, string> = {
    'intelliscore': 'IntelliScore',
    'misconfiguration': 'Misconfiguration',
    'assets': 'Assets',
    'cyber-resilience': 'Cyber Resilience',
    'compliance-trends': 'Compliance Trends',
    'mitre': 'MITRE ATT&CK',
    'cve': 'CVE Distribution',
    'tags': 'Tags',
    'onprem-classification': 'On-Prem Classification',
    'cloud-account': 'Cloud Account',
    'top-misconfiguration': 'Top Misconfiguration',
    'onprem-lowest-score': 'Lowest Score Assets',
    'onprem-lowest-cve': 'Lowest CVE Score',
    'onprem-lowest-compliance': 'Lowest Compliance',
    'top-cve': 'Top CVEs',
    'jira-tickets': 'JIRA Tickets'
  };

  const handleResetLayout = () => {
    if (isResetDisabled) return; // Prevent multiple clicks
    
    setIsResetDisabled(true);
    
    // Reset discards unsaved changes and reloads from saved preferences (user's default)
    localStorage.removeItem('dashboard-layout');
    localStorage.removeItem('hidden-widgets');
    localStorage.removeItem('dashboard-user-type');

    // Load saved preferences from userDetails (this is the user's saved default)
    const userDetailsStr = localStorage.getItem('userDetails');
    if (userDetailsStr) {
      try {
        const userDetails = JSON.parse(userDetailsStr);
        if (userDetails.dashboard_preferences) {
          // User has saved preferences - reload them
          const savedLayout = userDetails.dashboard_preferences.layout;
          const savedHiddenWidgets = userDetails.dashboard_preferences.hidden_widgets || [];
          
          if (savedLayout?.lg) {
            setLayouts(savedLayout);
            localStorage.setItem('dashboard-layout', JSON.stringify(savedLayout));
          } else {
            setLayouts(getFilteredLayouts());
          }
          
          setHiddenWidgets(new Set(savedHiddenWidgets));
          localStorage.setItem('hidden-widgets', JSON.stringify(savedHiddenWidgets));
          
          toast.success('Dashboard reset to saved preferences', { type: 'success' });
          
          // Re-enable button after 6 seconds (toast completes in 5 seconds)
          setTimeout(() => setIsResetDisabled(false), 6000);
          return;
        }
      } catch (e) {
        console.warn('Failed to load saved preferences:', e);
      }
    }

    // No saved preferences - reset to system default
    setLayouts(getFilteredLayouts());
    setHiddenWidgets(new Set());

    toast.success('Dashboard layout reset to default', { type: 'success' });
    
    // Re-enable button after 6 seconds (toast completes in 5 seconds)
    setTimeout(() => setIsResetDisabled(false), 6000);
  };

  const handleSavePreferences = async () => {
    if (isSaveDisabled) return; // Prevent multiple clicks
    
    setIsSaveDisabled(true);
    
    try {
      // Build payload from current state
      const payload = {
        layout: {
          lg: layouts.lg?.map((item: any) => ({
            i: item.i,
            x: item.x,
            y: item.y,
            w: item.w,
            h: item.h
          })) || []
        },
        hidden_widgets: [...hiddenWidgets]
      };

      const response = await axiosInstance.post(END_POINTS.DASHBOARD_PREFERENCES, payload);
      
      if (response.status === 200) {
        // Update userDetails in localStorage with new preferences
        // This ensures page refresh also loads the saved preferences
        const userDetailsStr = localStorage.getItem('userDetails');
        if (userDetailsStr) {
          try {
            const userDetails = JSON.parse(userDetailsStr);
            userDetails.dashboard_preferences = payload;
            localStorage.setItem('userDetails', JSON.stringify(userDetails));
          } catch (e) {
            console.warn('Failed to update userDetails localStorage:', e);
          }
        }
        
        toast.success('Dashboard preferences saved successfully', { type: 'success' });
      }
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || error?.message || 'Failed to save preferences';
      toast.error(errorMessage);
      console.error('Error saving dashboard preferences:', error);
    } finally {
      // Re-enable button after 6 seconds (toast completes in 5 seconds)
      setTimeout(() => setIsSaveDisabled(false), 6000);
    }
  };

  const toggleWidgetVisibility = (widgetId: string) => {
    const newHiddenWidgets = new Set(hiddenWidgets);
    if (newHiddenWidgets.has(widgetId)) {
      newHiddenWidgets.delete(widgetId);

      const existsInLayout = layouts.lg?.some((item: any) => item.i === widgetId);
      if (!existsInLayout) {
        const defaultWidget = defaultLayouts.lg.find((item: any) => item.i === widgetId);
        if (defaultWidget) {
          const newLayout = [...(layouts.lg || []), defaultWidget];
          const updatedLayouts = { ...layouts, lg: newLayout };
          setLayouts(updatedLayouts);
          localStorage.setItem('dashboard-layout', JSON.stringify(updatedLayouts));
        }
      }
    } else {
      newHiddenWidgets.add(widgetId);
    }
    setHiddenWidgets(newHiddenWidgets);
    localStorage.setItem('hidden-widgets', JSON.stringify([...newHiddenWidgets]));

    setWidgetToggleAnchor(null);
  };

  const getAllWidgets = () => {
    return Object.keys(widgetNames);
  };

  const isUserTypeDetermined = isNewUserTrue || isOnlyCloudUser || isOnlyPremAssetUser || isBothCloudAndPremAssetUser;

  return (
    <DashboardProvider
      dashboardData={dashboardData}
      isLoading={isLoading}
      error={null}
      isOverlayOpen={isOverlayOpen}
      setIsOverlayOpen={setIsOverlayOpen}
    >
      {!isUserTypeDetermined ? (
        <Loading />
      ) : isNewUserTrue ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "80vh",
          }}
        >
          <img src={NoData_img1} alt="" style={{ width: 300 }} />
          <Typography
            variant="body2"
            sx={{ fontWeight: 500, fontSize: "18px", mt: 2 }}
          >
            Welcome to Spark!
          </Typography>
          {isAssetInventory() !== 1 && (
            <>
              {hasPermissions(ROLES_ROUTE.NEW_SCAN) ? (
                <>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 400, fontSize: "14px", mb: 2 }}
                  >
                    Let's get started by scanning your first asset by clicking the
                    button below.
                  </Typography>

                  <Button
                    variant="contained"
                    onClick={() => navigate("/on-premises/new-newscan")}
                  >
                    Scan Now
                  </Button>
                </>
              ) : (
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 400, fontSize: "14px", mb: 2 }}
                >
                  No assets found.
                </Typography>
              )}
            </>
          )}

        </Box>
      ) : (
        <Container
          maxWidth={false}
          style={{ padding: "0px" }}
          sx={{
            px: 0,
            ...styles.container,
          }}
        >
          {/* Right Sidebar */}
          <Box
            className="dashboard-sidebar"
            sx={{
              position: 'fixed',
              right: '-50px',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 1000,
              width: '60px',
              background: isDarkMode ? '#fff' : '#2d3748',
              borderRadius: '12px 0 0 12px',
              boxShadow: isDarkMode ? '-2px 0 12px rgba(0, 0, 0, 0.08)' : '-2px 0 12px rgba(0, 0, 0, 0.3)',
              border: `1px solid ${isDarkMode ? '#e5e7eb' : '#4a5568'}`,
              borderRight: 'none',
              py: 1.5,
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              transition: 'right 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                right: 0,
              }
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                left: '-20px',
                top: 0,
                width: '20px',
                height: '100%',
                cursor: 'pointer',
              }}
            />
            {/* Manage Widgets */}
            <Box
              onClick={() => setWidgetToggleAnchor(document.getElementById('sidebar-anchor'))}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                py: 1.5,
                px: 0.5,
                transition: 'all 0.2s ease',
                borderRadius: '8px',
                mx: 0.5,
                '&:hover': {
                  background: isDarkMode ? '#f3f4f6' : '#374151',
                  '& .icon': {
                    color: '#696595',
                  }
                }
              }}
            >
              <Settings
                className="icon"
                sx={{
                  fontSize: '20px',
                  color: isDarkMode ? '#6b7280' : '#e2e8f0',
                  mb: 0.5,
                  transition: 'color 0.2s ease'
                }}
              />
              <Typography
                sx={{
                  fontSize: '9px',
                  fontWeight: 500,
                  color: isDarkMode ? '#6b7280' : '#e2e8f0',
                  textAlign: 'center',
                  lineHeight: 1.2,
                }}
              >
                Manage
              </Typography>
            </Box>

            {/* Reset Layout */}
            <Box
              onClick={handleResetLayout}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                py: 1.5,
                px: 0.5,
                transition: 'all 0.2s ease',
                borderRadius: '8px',
                mx: 0.5,
                '&:hover': {
                  background: isDarkMode ? '#f3f4f6' : '#374151',
                  '& .icon': {
                    color: '#696595',
                  }
                }
              }}
            >
              <Box
                className="icon"
                component="span"
                sx={{
                  fontSize: '20px',
                  color: isDarkMode ? '#6b7280' : '#e2e8f0',
                  mb: 0.5,
                  transition: 'color 0.2s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                ↻
              </Box>
              <Typography
                sx={{
                  fontSize: '9px',
                  fontWeight: 500,
                  color: isDarkMode ? '#6b7280' : '#e2e8f0',
                  textAlign: 'center',
                  lineHeight: 1.2,
                }}
              >
                Reset
              </Typography>
            </Box>

            {/* Save Preferences */}
            <Box
              onClick={handleSavePreferences}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                py: 1.5,
                px: 0.5,
                transition: 'all 0.2s ease',
                borderRadius: '8px',
                mx: 0.5,
                '&:hover': {
                  background: isDarkMode ? '#f3f4f6' : '#374151',
                  '& .icon': {
                    color: '#696595',
                  }
                }
              }}
            >
              <Save
                className="icon"
                sx={{
                  fontSize: '20px',
                  color: isDarkMode ? '#6b7280' : '#e2e8f0',
                  mb: 0.5,
                  transition: 'color 0.2s ease'
                }}
              />
              <Typography
                sx={{
                  fontSize: '9px',
                  fontWeight: 500,
                  color: isDarkMode ? '#6b7280' : '#e2e8f0',
                  textAlign: 'center',
                  lineHeight: 1.2,
                }}
              >
                Save
              </Typography>
            </Box>
          </Box>

          <Box id="sidebar-anchor" sx={{ position: 'fixed', right: '60px', top: '50%' }} />

          {/* Widget Toggle Menu */}
          <Menu
            anchorEl={widgetToggleAnchor}
            open={Boolean(widgetToggleAnchor)}
            onClose={() => setWidgetToggleAnchor(null)}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'right',
            }}
            PaperProps={{
              sx: {
                width: 280,
                maxHeight: 480,
                borderRadius: '12px',
                boxShadow: isDarkMode
                  ? '0 8px 24px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.1)'
                  : '0 4px 16px rgba(0, 0, 0, 0.1)',
                border: isDarkMode ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #e5e7eb',
                bgcolor: isDarkMode ? '#1e293b' : '#ffffff',
                mr: 1,
                overflow: 'hidden',
              }
            }}
          >
            <Box
              sx={{
                px: 2.5,
                py: 2,
                borderBottom: isDarkMode ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #e5e7eb',
                background: isDarkMode ? '#0f172a' : '#fafafa',
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 600,
                  color: isDarkMode ? '#f1f5f9' : '#374151',
                  fontSize: '14px'
                }}
              >
                Toggle Widgets
              </Typography>
            </Box>

            <Box
              sx={{
                maxHeight: 400,
                overflowY: 'auto',
                bgcolor: isDarkMode ? '#1e293b' : '#ffffff',
                '&::-webkit-scrollbar': {
                  width: '6px',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'transparent',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: isDarkMode ? 'rgba(255, 255, 255, 0.2)' : '#d1d5db',
                  borderRadius: '3px',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: isDarkMode ? 'rgba(255, 255, 255, 0.3)' : '#9ca3af',
                }
              }}
            >
              {getAllWidgets().map((widgetId) => (
                <MenuItem
                  key={widgetId}
                  onClick={() => toggleWidgetVisibility(widgetId)}
                  sx={{
                    py: 1.5,
                    px: 2.5,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    bgcolor: isDarkMode ? '#1e293b' : '#ffffff',
                    '&:hover': {
                      background: isDarkMode ? 'rgba(105, 101, 149, 0.15)' : '#f9fafb',
                    }
                  }}
                >
                  <ListItemText
                    primary={widgetNames[widgetId] || widgetId}
                    sx={{
                      '& .MuiListItemText-primary': {
                        fontSize: '13px',
                        fontWeight: 500,
                        color: isDarkMode ? '#e2e8f0' : '#374151',
                      }
                    }}
                  />
                  <Switch
                    checked={!hiddenWidgets.has(widgetId)}
                    size="small"
                    sx={{
                      '& .MuiSwitch-switchBase.Mui-checked': {
                        color: '#696595',
                      },
                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: '#696595',
                        opacity: 1,
                      },
                      '& .MuiSwitch-track': {
                        backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.2)' : '#d1d5db',
                      },
                      '& .MuiSwitch-switchBase': {
                        color: isDarkMode ? '#94a3b8' : '#9ca3af',
                      }
                    }}
                  />
                </MenuItem>
              ))}
            </Box>
          </Menu>

          <ResponsiveGridLayout
            className="layout"
            layouts={layouts}
            onLayoutChange={onLayoutChange}
            onResizeStop={onResizeStop}
            breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
            cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
            rowHeight={60}
            margin={[12, 12]}
            containerPadding={[0, 0]}
            isDraggable={!widgetToggleAnchor && !isOverlayOpen}
            isResizable={true}
            resizeHandles={['se', 'sw', 'ne', 'nw']}
            draggableCancel=".no-drag, button, .MuiIconButton-root, .MuiSwitch-root, .MuiButtonBase-root, input, select, textarea, a, .ag-cell, .ag-header-cell, .MuiChip-root, .clickable-area, .ag-tooltip, .ag-tooltip-custom, .MuiTooltip-popper, .MuiTooltip-tooltip"
            compactType="vertical"
            preventCollision={false}
            allowOverlap={false}
            autoSize={true}
            useCSSTransforms={true}
            style={{ background: 'transparent' }}
          >
            {layouts.lg?.find((item: any) => item.i === 'intelliscore') && !hiddenWidgets.has('intelliscore') && (
              <div key="intelliscore">
                <IntelliScore />
              </div>
            )}
            {layouts.lg?.find((item: any) => item.i === 'misconfiguration') && !hiddenWidgets.has('misconfiguration') && (
              <div key="misconfiguration">
                <Misconfiguration />
              </div>
            )}
            {layouts.lg?.find((item: any) => item.i === 'assets') && !hiddenWidgets.has('assets') && (
              <div key="assets">
                <Assets />
              </div>
            )}

            {layouts.lg?.find((item: any) => item.i === 'cyber-resilience') && !hiddenWidgets.has('cyber-resilience') && (
              <div key="cyber-resilience">
                <CyberResilienceView />
              </div>
            )}
            {layouts.lg?.find((item: any) => item.i === 'compliance-trends') && !hiddenWidgets.has('compliance-trends') && (
              <div key="compliance-trends">
                <ComplianceTrends height={300} />
              </div>
            )}

            {layouts.lg?.find((item: any) => item.i === 'mitre') && !hiddenWidgets.has('mitre') && (
              <div key="mitre">
                <Mitre />
              </div>
            )}
            {layouts.lg?.find((item: any) => item.i === 'cve') && !hiddenWidgets.has('cve') && (
              <div key="cve">
                <Cve />
              </div>
            )}
            {layouts.lg?.find((item: any) => item.i === 'tags') && !hiddenWidgets.has('tags') && (
              <div key="tags">
                <Tags height={420} />
              </div>
            )}

            {layouts.lg?.find((item: any) => item.i === 'onprem-classification') && !hiddenWidgets.has('onprem-classification') && (
              <div key="onprem-classification">
                <OnPremClassification />
              </div>
            )}
            {layouts.lg?.find((item: any) => item.i === 'cloud-account') && !hiddenWidgets.has('cloud-account') && (
              <div key="cloud-account">
                <CloudAccount />
              </div>
            )}

            {layouts.lg?.find((item: any) => item.i === 'top-misconfiguration') && !hiddenWidgets.has('top-misconfiguration') && (
              <div key="top-misconfiguration">
                <TopMisconfiguration
                  isbothCloudAndPremAssetUser={isBothCloudAndPremAssetUser}
                  isOnlyPremAssetUser={isOnlyPremAssetUser}
                  isOnlyCloudUser={isOnlyCloudUser}
                />
              </div>
            )}
            {layouts.lg?.find((item: any) => item.i === 'onprem-lowest-score') && !hiddenWidgets.has('onprem-lowest-score') && (
              <div key="onprem-lowest-score">
                <OnPremLowestScore
                  isbothCloudAndPremAssetUser={isBothCloudAndPremAssetUser}
                  isOnlyPremAssetUser={isOnlyPremAssetUser}
                  isOnlyCloudUser={isOnlyCloudUser}
                />
              </div>
            )}
            {layouts.lg?.find((item: any) => item.i === 'onprem-lowest-cve') && !hiddenWidgets.has('onprem-lowest-cve') && (
              <div key="onprem-lowest-cve">
                <OnPremLowestCveScore />
              </div>
            )}
            {layouts.lg?.find((item: any) => item.i === 'onprem-lowest-compliance') && !hiddenWidgets.has('onprem-lowest-compliance') && (
              <div key="onprem-lowest-compliance">
                <OnPremLowestCompliance
                  isbothCloudAndPremAssetUser={isBothCloudAndPremAssetUser}
                  isOnlyPremAssetUser={isOnlyPremAssetUser}
                  isOnlyCloudUser={isOnlyCloudUser}
                />
              </div>
            )}
            {layouts.lg?.find((item: any) => item.i === 'top-cve') && !hiddenWidgets.has('top-cve') && (
              <div key="top-cve">
                <TopCve />
              </div>
            )}
            {layouts.lg?.find((item: any) => item.i === 'jira-tickets') && !hiddenWidgets.has('jira-tickets') && (
              <div key="jira-tickets">
                <JiraTickets />
              </div>
            )}
          </ResponsiveGridLayout>

          <style>{`
            .react-grid-item {
              transition: all 200ms ease-out;
              border-radius: 8px;
              overflow: hidden;
            }

            .react-grid-item:not(.react-grid-placeholder) {
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            }

            .react-grid-item:hover:not(.react-draggable-dragging):not(.resizing) {
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
            }

            /* Make the grid item draggable by default */
            .react-grid-item:not(.no-drag):not(.react-draggable-dragging):not(.resizing) {
              cursor: move;
            }

            /* Prevent dragging on specific elements */
            .react-grid-item .no-drag,
            .react-grid-item .clickable-area {
              cursor: pointer !important;
            }

            /* Items with zero value - no pointer */
            .react-grid-item .no-click {
              cursor: default !important;
            }

            /* Ensure charts and interactive elements are clickable */
            .react-grid-item .no-drag * {
              cursor: pointer !important;
            }

            /* Override for no-click children */
            .react-grid-item .no-click,
            .react-grid-item .no-click * {
              cursor: default !important;
            }

            .react-grid-item.react-draggable-dragging {
              box-shadow: 0 12px 32px rgba(59, 130, 246, 0.5) !important;
              z-index: 100 !important;
              opacity: 0.95 !important;
              cursor: grabbing !important;
            }

            .react-grid-item.resizing {
              box-shadow: 0 8px 24px rgba(59, 130, 246, 0.3) !important;
              outline: 2px dashed #3b82f6 !important;
              outline-offset: -2px;
              z-index: 50 !important;
            }

            .react-grid-item > .react-resizable-handle {
              opacity: 0;
              transition: opacity 0.2s ease;
              z-index: 10;
            }

            .react-grid-item:hover > .react-resizable-handle {
              opacity: 0.7;
            }

            .react-grid-item > .react-resizable-handle:hover {
              opacity: 1 !important;
            }

            .react-grid-item > .react-resizable-handle-se,
            .react-grid-item > .react-resizable-handle-sw,
            .react-grid-item > .react-resizable-handle-ne,
            .react-grid-item > .react-resizable-handle-nw {
              width: 10px;
              height: 10px;
              background: #3b82f6;
              border: 2px solid #ffffff;
              border-radius: 50%;
              box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
            }

            .react-grid-item > .react-resizable-handle-se {
              bottom: 6px;
              right: 6px;
              cursor: se-resize;
            }

            .react-grid-item > .react-resizable-handle-sw {
              bottom: 6px;
              left: 6px;
              cursor: sw-resize;
            }

            .react-grid-item > .react-resizable-handle-ne {
              top: 6px;
              right: 6px;
              cursor: ne-resize;
            }

            .react-grid-item > .react-resizable-handle-nw {
              top: 6px;
              left: 6px;
              cursor: nw-resize;
            }

            .react-grid-item.react-grid-placeholder {
              background: rgba(59, 130, 246, 0.15) !important;
              border: 2px dashed rgba(59, 130, 246, 0.6) !important;
              border-radius: 8px !important;
              opacity: 1 !important;
              transition: all 150ms ease !important;
            }

            .react-grid-item.react-draggable-dragging *,
            .react-grid-item.resizing * {
              user-select: none !important;
            }

            .react-grid-item > div {
              width: 100%;
              height: 100%;
              overflow: hidden;
            }
            
            .react-grid-item canvas,
            .react-grid-item svg {
              max-width: 100% !important;
              max-height: 100% !important;
            }
            
            .react-grid-item .recharts-wrapper,
            .react-grid-item .recharts-surface {
              width: 100% !important;
              height: 100% !important;
            }

            .react-grid-item .ag-root-wrapper {
              overflow: hidden !important;
            }

            .react-grid-item .ag-body-viewport {
              overflow: auto !important;
            }

            .react-grid-item .ag-body-viewport::-webkit-scrollbar {
              width: 8px;
              height: 8px;
            }

            .react-grid-item .ag-body-viewport::-webkit-scrollbar-track {
              background: #f1f1f1;
              border-radius: 4px;
            }

            .react-grid-item .ag-body-viewport::-webkit-scrollbar-thumb {
              background: #888;
              border-radius: 4px;
            }

            .react-grid-item .ag-body-viewport::-webkit-scrollbar-thumb:hover {
              background: #555;
            }

            .react-grid-item > div {
              height: 100%;
              display: flex;
              flex-direction: column;
            }

            .react-grid-item [data-theme] {
              height: 100%;
              display: flex;
              flex-direction: column;
            }

            .react-grid-item [data-theme] > div[class*="container"] {
              flex: 1;
              display: flex;
              flex-direction: column;
              min-height: 0;
            }

            .react-grid-item [class*="header"] {
              flex-shrink: 0;
            }

            .react-grid-item [class*="data_container"] {
              flex: 1;
              min-height: 0;
              height: auto !important;
              max-height: none !important;
            }
          `}</style>

        </Container>
      )}

      {openDialog && (
        <ExpiredAccountDialog
          open={openDialog}
          userData={userData}
          isNewUserDetails={isNewUserDetails}
          onClose={() => {
            setOpenDialog(false);
          }}
          onDelete={() => {
            handleOpenDialog("delete");
            setOpenDialog(false);
          }}
          onupgrade={() => {
            setOpenDialog(false);
            setIsViewPlans(true);
          }}
        />
      )}

      {openDeactivateDialog && (
        <DeactivateAccountDialog
          open={openDeactivateDialog}
          onClose={() => {
            setOpenDeactivateDialog(false);
          }}
        />
      )}

      {dialogType === "delete" && (
        <Dialog
          sx={{
            "& .MuiDialog-paper": {
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "380px",
              // Use a smaller minHeight when SSO is enabled so we don't see
              // Use a smaller minHeight when SSO is enabled so the dialog is compact
              // (password field is hidden). Keep larger height for non-SSO flow.
              minHeight: isSsoEnabled ? 120 : 270,
              transform: "translate(-50%, -50%)",
              borderRadius: 2,
            },
          }}
          open={true}
          onClose={handleCloseDialog}
        >
          <DialogTitle>
            <Typography variant="h6" component="p">
              Are you sure you want to delete your data permanently?
            </Typography>
          </DialogTitle>
          <DialogContent>
            {/* If user logged in via SSO (organization has SSO enabled), skip password prompt
                and show only yes/no buttons. Otherwise show password field as before. */}
            {!isSsoEnabled && (
              <TextField
                label="Password"
                type={showPassword ? "text" : "password"}
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                error={!!passwordError}
                helperText={passwordError}
                margin="normal"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    ...(!showPassword && { font: "initial" }),
                    borderRadius: 1,
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {showPassword ? (
                        <Visibility
                          sx={{ cursor: "pointer" }}
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      ) : (
                        <VisibilityOff
                          sx={{ cursor: "pointer" }}
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
            )}
            {/* No extra text for SSO users - only buttons per request */}
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              gap: "10px",
              justifyContent: "center",
              marginBottom: "10px",
            }}
          >
            <Button
              sx={{
                width: "120px",
                color: "#696595",
                borderColor: "#696595",
                borderRadius: 1,
              }}
              variant="outlined"
              onClick={(event) => handleCloseDialog(event, "cancel")}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                // If SSO is enabled for this user/org, skip password confirmation
                // and navigate directly to the delete flow which performs deletion.
                if (isSsoEnabled) {
                  setDialogType(null);
                  navigate("/login/delete");
                  return;
                }
                handleDelete(password);
              }}
              sx={{
                width: "120px",
                background: "#FB4B50",
                color: "white",
                borderRadius: 1,
                "&:hover": {
                  background: "#e03b40",
                },
              }}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {isViewPlans && (
        <Dialog
          open={isViewPlans}
          onClose={() => setIsViewPlans(false)}
          fullWidth
          maxWidth="md"
          sx={{
            "& .MuiDialog-paper": {
              borderRadius: 2,
              overflow: "hidden",
            },
          }}
        >
          <SubscriptionViewPlan
            setIsViewPlans={setIsViewPlans}
            isViewPlans={isViewPlans}
            onupgrade={() => {
              if (daysdiff <= 0) {
                setOpenDialog(true);
              } else {
                setOpenDialog(false);
              }
            }}
          />
        </Dialog>
      )}
    </DashboardProvider>
  );
};

const styles = {
  container: {
    overflowY: "auto",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
};

export default Home;
